import Weather0 from '../../icons/Weather0';
import Weather0Colored from '../../icons/Weather0Colored';
import Weather1 from '../../icons/Weather1';
import Weather1Colored from '../../icons/Weather1Colored';
import Weather2 from '../../icons/Weather2';
import Weather2Colored from '../../icons/Weather2Colored';
import Weather3 from '../../icons/Weather3';
import Weather3Colored from '../../icons/Weather3Colored';
import Weather4 from '../../icons/Weather4';
import Weather4Colored from '../../icons/Weather4Colored';
import Weather5 from '../../icons/Weather5';
import Weather5Colored from '../../icons/Weather5Colored';
import Weather6 from '../../icons/Weather6';
import Weather6Colored from '../../icons/Weather6Colored';
import Weather7 from '../../icons/Weather7';
import Weather7Colored from '../../icons/Weather7Colored';
import Weather8 from '../../icons/Weather8';
import Weather8Colored from '../../icons/Weather8Colored';
import Weather9 from '../../icons/Weather9';
import Weather9Colored from '../../icons/Weather9Colored';
import Weather10 from '../../icons/Weather10';
import Weather10Colored from '../../icons/Weather10Colored';
import Weather11 from '../../icons/Weather11';
import Weather11Colored from '../../icons/Weather11Colored';
import Weather12 from '../../icons/Weather12';
import Weather12Colored from '../../icons/Weather12Colored';
import Weather13 from '../../icons/Weather13';
import Weather13Colored from '../../icons/Weather13Colored';
import Weather14 from '../../icons/Weather14';
import Weather14Colored from '../../icons/Weather14Colored';
import Weather15 from '../../icons/Weather15';
import Weather15Colored from '../../icons/Weather15Colored';
import Weather16 from '../../icons/Weather16';
import Weather16Colored from '../../icons/Weather16Colored';
import Weather17 from '../../icons/Weather17';
import Weather17Colored from '../../icons/Weather17Colored';
import Weather18 from '../../icons/Weather18';
import Weather18Colored from '../../icons/Weather18Colored';
import Weather19 from '../../icons/Weather19';
import Weather19Colored from '../../icons/Weather19Colored';
import Weather20 from '../../icons/Weather20';
import Weather20Colored from '../../icons/Weather20Colored';
import Weather21 from '../../icons/Weather21';
import Weather21Colored from '../../icons/Weather21Colored';
import Weather22 from '../../icons/Weather22';
import Weather22Colored from '../../icons/Weather22Colored';
import Weather23 from '../../icons/Weather23';
import Weather23Colored from '../../icons/Weather23Colored';
import Weather24 from '../../icons/Weather24';
import Weather24Colored from '../../icons/Weather24Colored';
import Weather25 from '../../icons/Weather25';
import Weather25Colored from '../../icons/Weather25Colored';
import Weather26 from '../../icons/Weather26';
import Weather26Colored from '../../icons/Weather26Colored';
import Weather27 from '../../icons/Weather27';
import Weather27Colored from '../../icons/Weather27Colored';
import Weather28 from '../../icons/Weather28';
import Weather28Colored from '../../icons/Weather28Colored';
import Weather29 from '../../icons/Weather29';
import Weather29Colored from '../../icons/Weather29Colored';
import Weather30 from '../../icons/Weather30';
import Weather30Colored from '../../icons/Weather30Colored';
import Weather31 from '../../icons/Weather31';
import Weather31Colored from '../../icons/Weather31Colored';
import Weather32 from '../../icons/Weather32';
import Weather32Colored from '../../icons/Weather32Colored';
import Weather33 from '../../icons/Weather33';
import Weather33Colored from '../../icons/Weather33Colored';
import Weather34 from '../../icons/Weather34';
import Weather34Colored from '../../icons/Weather34Colored';
import Weather35 from '../../icons/Weather35';
import Weather35Colored from '../../icons/Weather35Colored';
import Weather36 from '../../icons/Weather36';
import Weather36Colored from '../../icons/Weather36Colored';
import Weather37 from '../../icons/Weather37';
import Weather37Colored from '../../icons/Weather37Colored';
import Weather38 from '../../icons/Weather38';
import Weather38Colored from '../../icons/Weather38Colored';
import Weather39 from '../../icons/Weather39';
import Weather39Colored from '../../icons/Weather39Colored';
import Weather40 from '../../icons/Weather40';
import Weather40Colored from '../../icons/Weather40Colored';
import Weather41 from '../../icons/Weather41';
import Weather41Colored from '../../icons/Weather41Colored';
import Weather42 from '../../icons/Weather42';
import Weather42Colored from '../../icons/Weather42Colored';
import Weather43 from '../../icons/Weather43';
import Weather43Colored from '../../icons/Weather43Colored';
import Weather44 from '../../icons/Weather44';
import Weather44Colored from '../../icons/Weather44Colored';
import Weather45 from '../../icons/Weather45';
import Weather45Colored from '../../icons/Weather45Colored';
import Weather46 from '../../icons/Weather46';
import Weather46Colored from '../../icons/Weather46Colored';
import Weather47 from '../../icons/Weather47';
import Weather47Colored from '../../icons/Weather47Colored';
import { IconComponent, IconProps } from '../Icon';

const weatherIcons: Record<string, IconComponent> = {
  Weather0,
  Weather0Colored,
  Weather1,
  Weather1Colored,
  Weather2,
  Weather2Colored,
  Weather3,
  Weather3Colored,
  Weather4,
  Weather4Colored,
  Weather5,
  Weather5Colored,
  Weather6,
  Weather6Colored,
  Weather7,
  Weather7Colored,
  Weather8,
  Weather8Colored,
  Weather9,
  Weather9Colored,
  Weather10,
  Weather10Colored,
  Weather11,
  Weather11Colored,
  Weather12,
  Weather12Colored,
  Weather13,
  Weather13Colored,
  Weather14,
  Weather14Colored,
  Weather15,
  Weather15Colored,
  Weather16,
  Weather16Colored,
  Weather17,
  Weather17Colored,
  Weather18,
  Weather18Colored,
  Weather19,
  Weather19Colored,
  Weather20,
  Weather20Colored,
  Weather21,
  Weather21Colored,
  Weather22,
  Weather22Colored,
  Weather23,
  Weather23Colored,
  Weather24,
  Weather24Colored,
  Weather25,
  Weather25Colored,
  Weather26,
  Weather26Colored,
  Weather27,
  Weather27Colored,
  Weather28,
  Weather28Colored,
  Weather29,
  Weather29Colored,
  Weather30,
  Weather30Colored,
  Weather31,
  Weather31Colored,
  Weather32,
  Weather32Colored,
  Weather33,
  Weather33Colored,
  Weather34,
  Weather34Colored,
  Weather35,
  Weather35Colored,
  Weather36,
  Weather36Colored,
  Weather37,
  Weather37Colored,
  Weather38,
  Weather38Colored,
  Weather39,
  Weather39Colored,
  Weather40,
  Weather40Colored,
  Weather41,
  Weather41Colored,
  Weather42,
  Weather42Colored,
  Weather43,
  Weather43Colored,
  Weather44,
  Weather44Colored,
  Weather45,
  Weather45Colored,
  Weather46,
  Weather46Colored,
  Weather47,
  Weather47Colored
};

type WeatherIconProps = {
  colored?: boolean;
  iconCode: string | number; // 0 - 47
};

export const getWeatherIcon = (iconCode: string | number, colored = false): IconComponent | undefined => {
  const key = `Weather${iconCode}${colored ? 'Colored' : ''}`;
  return weatherIcons[key];
};

const WeatherIcon = ({ colored, iconCode, ...iconProps }: WeatherIconProps & IconProps) => {
  const Icon = getWeatherIcon(iconCode, colored);
  return Icon ? <Icon {...iconProps} /> : null;
};

export default WeatherIcon;
